module.exports = __webpack_public_path__ + "bbb1a5ce419549f9947102cf2fc2a0c0.png"


/*****************
 ** WEBPACK FOOTER
 ** ./app/static/images/NTPtour_image04.png
 ** module id = 172
 ** module chunks = 0
 **/